import { apiFetch, HttpError } from "~/api-fetch/apiFetch";
import { WolfkrowUser } from "~/Auth/WolfkrowUser";
import { reportError } from "~/error-handler/reportError";
import { useDownloadFile } from "~/file-loading/useDownloadFile";

type DownloadProjectTimePdfArgs = {
  url: string;
  filename: string;
  token: string | null;
  user: Pick<WolfkrowUser, "isImpersonating" | "email">;
  download: ReturnType<typeof useDownloadFile>;
};

export async function downloadProjectTimePdf({
  url,
  filename,
  token,
  user,
  download,
}: DownloadProjectTimePdfArgs): Promise<void> {
  const res = await apiFetch(
    url,
    {
      method: "get",
      headers: {
        "Content-Type": "application/pdf",
        Authorization: token ? `Bearer ${token}` : "",
        impersonation: user.isImpersonating ? user.email : "",
      },
    },
    { operation: "downloadProjectTimePdf" }
  );

  if (res.status === 200) {
    const blob = await res.blob();
    const file = new Blob([blob], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    download({ linkHref: fileURL, filename });
  } else {
    // Nothing is shown to the user for a failed response; it is only classified.
    reportError(HttpError.fromResponse(res));
  }
}
